import React, { useCallback, useRef, useState } from "react";
// import { useEffect } from "react";
import InputFormPanel from "./ui/InputFormPanel";
import Carousel from "./ui/Carousel";
import ButtonGroup from "./ui/ButtonGroup";
import { ButtonKeyFrame } from "./ui";
import { CalendarDaysIcon, TableCellsIcon, InformationCircleIcon, SunIcon } from "@heroicons/react/20/solid";
import CheckSelectInput from "./ui/CheckSelectInput";
import useFormPanel from "./hooks/useFormPanel";
import InputFormPanelMUI from "./ui_MUI/InputFormPanelMUI";
import InputSelectoForm from "./ui_MUI/InputSelectoForm";
import AlertMUI from "./ui_MUI/AlertMUI";

export default function FormsPanel({ className, datos, onModifyDatos }) {
  // console.warn("datos --> ", datos)
  const [indexButton, setIndexButton] = useState(0);
  const { formState, onInputChange } = useFormPanel(datos, setIndexButton)
  const [alert, setAlert] = useState([])
  const refsArray = [useRef(null), useRef(null), useRef(null)];
  const hForm = useRef(null);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formState.disparo1Tajo && (!formState.disparo1Hora || formState.disparo1Hora === 'Invalid Date')) {
      handleInvalid({ target: { id: 'disparo-0-Hora' } });
      return;
    }
    if (formState.disparo2Tajo && (!formState.disparo2Hora || formState.disparo2Hora === 'Invalid Date')) {
      handleInvalid({ target: { id: 'disparo-1-Hora' } });
      return;
    }
    // if (formState.disparo3Tajo && (!formState.disparo3Hora || formState.disparo3Hora === 'Invalid Date')) {
    //   handleInvalid({ target: { id: 'disparo-2-Hora' } });
    //   return;
    // }
    onModifyDatos(formState);
  };

  const handleInvalid = (e) => {
    setAlert([{ alert: 'Error', textAlert: 'Falta completar el formulario' }])
    if (e.target.form) {

      const form = e.target.form;
      const invalidFields = Array.from(form.elements).filter((input) => !input.validity.valid);
      if (invalidFields.length > 0) {
        if (e.target.id.split('-')[1]) {
          e.preventDefault();
          refsArray[e.target.id.split('-')[1]].current.click()
          invalidFields[0].parentNode.parentNode.classList.add('animate-aniInput');
          setTimeout(() => { invalidFields[0].parentNode.parentNode.classList.remove('animate-aniInput'); }, 2000);
        } else {
          hForm.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    } else {
      refsArray[e.target.id.split('-')[1]].current.click()
    }
  };

  const handleButtonClick = (index) => {
    setIndexButton(index);
  };

  const formatDateToISO = (dateString) => {
    if (!dateString) return '';
    const isoFormat = /^\d{4}-\d{2}-\d{2}$/;
    if (isoFormat.test(dateString)) return dateString;
    const [day, month, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
  };

  const handleAlerts = useCallback((newAlerts) => {
    setAlert(newAlerts);
  }, [setAlert]);
  // console.warn("formState --> ", formState)
  return (
    <>
      <div ref={hForm} className={`divEnvolvente h-full relative overflow-auto content-center ${className}`}>
        <div className="sticky top-0 w-full bg-gradient-to-b from-[#0A2540] to-[#0F3460] py-3 lg:py-4 rounded-t-xl lg:rounded-t-2xl z-[2]">
          <h1 className="text-left font-bold text-lg lg:text-2xl antialiased text-white px-4">
            CONFIGURACIÓN
          </h1>
        </div>
        <form className="flex flex-col gap-5 py-5 border border-r-[#E5E5E5] pt-2" onSubmit={handleSubmit} onInvalid={handleInvalid} >
          {/* <div className="flex flex-col gap-y-4 px-5 font-Poppins text-sm">
            <p className="flex text-[#4D4D4D] gap-x-2 antialiased font-medium items-center">
              <TableCellsIcon
                className="h-5 w-5 shrink-0"
                aria-hidden="true"
              />
              OBSERVACIONES DE PANEL:
            </p>
            <InputFormPanel
              id='observacion'
              name="observacion"
              value={formState.observacion}
              onChange={({ target: { name, value } }) => (onInputChange({ [name]: value }))}
              required
            ></InputFormPanel>
          </div> */}
          <div className="flex flex-col gap-y-4 px-5 font-Poppins text-sm">
            <p className="flex text-[#4D4D4D] gap-x-2 antialiased font-medium items-center">
              <SunIcon
                className="h-5 w-5 shrink-0"
                aria-hidden="true"
              />
              BRILLOS:
            </p>
            <div className="w-full flex gap-4">
              {Object.entries(formState.Brightness).map(([key, brightness]) => (
                <InputSelectoForm key={key}
                  titulo={key === "Day" ? "Brillo de Dia" : "Brillo de Noche"}
                  datos={brightness}
                  name={key}
                  defaultValue={formState[`brightness${key}`]}
                  labels={{ Low: "BAJO", Intermediate: "MEDIO", Strong: "ALTO" }}
                  onInputChange={onInputChange}
                />
              ))}
            </div>
          </div>
          <p className="px-5 flex gap-2 text-[#4D4D4D] antialiased font-Poppins text-sm font-medium items-center">
            <CalendarDaysIcon
              className="h-6 w-6 shrink-0"
              aria-hidden="true"
            />
            FECHA:
          </p>
          <div className="flex gap-5 px-5 justify-between flex-wrap">
            <div className="w-full">
              <InputFormPanel
                id='fecha'
                name="fecha"
                value={formatDateToISO(formState?.fecha)}
                onChange={({ target: { name, value } }) => (onInputChange({ [name]: value }))}
                type="date"
                required
              ></InputFormPanel>
            </div>
          </div>
          <hr className="w-[100%] h-[1px] bg-[#E5E5E5]"></hr>
          <p className="px-5 flex gap-2 text-[#4D4D4D] antialiased font-Poppins text-sm font-medium items-center">
            <InformationCircleIcon
              className="h-6 w-6 shrink-0"
              aria-hidden="true"
            />
            TAJOS:
          </p>
          <div className="w-full flex flex-col gap-2 px-5 z-[1]">
            <CheckSelectInput
              label="DISPARO 1"
              checked={formState.disparo1Check}
              nameItem="disparo1Tajo"
              valueItem={formState.disparo1Tajo}
              onInputChange={onInputChange}
              handleButtonClick={handleButtonClick}
            />
            <CheckSelectInput
              label="DISPARO 2"
              checked={formState.disparo2Check}
              nameItem="disparo2Tajo"
              valueItem={formState.disparo2Tajo}
              onInputChange={onInputChange}
              handleButtonClick={handleButtonClick}
            />
            {/* <CheckSelectInput
              label="DISPARO 3"
              checked={formState.disparo3Check}
              nameItem="disparo3Tajo"
              valueItem={formState.disparo3Tajo}
              onInputChange={onInputChange}
              handleButtonClick={handleButtonClick}
            /> */}

          </div>
          {(formState.disparo1Tajo || formState.disparo2Tajo) &&
          //{(formState.disparo1Tajo || formState.disparo2Tajo || formState.disparo3Tajo) &&
            <>

              <ButtonGroup
                handleButtonClick={handleButtonClick}
                indexActive={indexButton}
                indexSelect={formState.disparo1Tajo ? 0 : formState.disparo2Tajo ? 1 : 2}
              >
                <span ref={refsArray[0]}> {formState.disparo1Tajo && "DISPARO 1"} </span>
                <span ref={refsArray[1]}> {formState.disparo2Tajo && "DISPARO 2"} </span>
                {/* <span ref={refsArray[2]}> {formState.disparo3Tajo && "DISPARO 3"} </span> */}
              </ButtonGroup>

              <Carousel posicion={indexButton}>
                {[...Array(2)].map((_, i) => (
                  formState[`disparo${i + 1}Tajo`] && (
                    <div key={`disparoContainer-${i}`} className="flex flex-col gap-y-6 px-5 py-2">
                      {
                        [{ name: 'Nivel', type: 'text' },
                        { name: 'Hora', type: 'time' }].map((item, _) => (
                          <InputFormPanelMUI
                            key={`disparo-${i}-${item.name}`}
                            id={`disparo-${i}-${item.name}`}
                            name={`disparo${i + 1}${item.name}`}
                            labelItem={item.name}
                            defaultValue={formState[`disparo${i + 1}${item.name}`]}
                            onInputChange={onInputChange}
                            type={item.type}
                            required
                          />
                        ))}
                    </div>
                  )
                ))}
              </Carousel>
            </>
          }
          <div className="w-full text-center ">
            <ButtonKeyFrame
              id="Enviar"
              type="submit"
              name="Enviar"
              value="Enviar"
            >
              Guardar
            </ButtonKeyFrame>
          </div>
        </form>
      </div>
      {alert.alert !== '' &&
        <AlertMUI Alerts={alert} hanldeAlerts={handleAlerts} />
      }
    </>
  );
}
